import { observer } from 'mobx-react';

import { CenteredSpinner } from '@servicetitan/standalone-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Loader } from '@servicetitan/web-components';

import { SuppressionStore } from '../stores/suppression.store';

export const SuppressionPage = provide({ singletons: [SuppressionStore] })(
    observer(() => {
        const [{ data, source, basename }] = useDependencies(SuppressionStore);

        return (
            <Loader
                data={data}
                src={source}
                className="w-100"
                basename={basename}
                loadingFallback={<CenteredSpinner />}
            />
        );
    }),
);
